import CircularProgress from '@mui/material/CircularProgress'
import { elementType } from 'prop-types'
import LoadingIcon from '../icons/loading-icon'

const Progress = ({ Icon, ...props }) => {
	return Icon ? <Icon {...props} /> : <CircularProgress {...props} />
}

Progress.defaultProps = {
	...CircularProgress.defaultProps,
	Icon: LoadingIcon,
	color: 'primary',
}

Progress.propTypes = {
	...CircularProgress.propTypes,
	Icon: elementType,
}

export default Progress
